import {IMaterialData} from '../../common-code/interfaces/materials/IMaterialData';

export const searchInMaterialData = (material: IMaterialData, searchText: string): boolean => {
    return searchText.length <= 0 || material.title.toLowerCase().includes(searchText.toLowerCase());
}